import { useEffect, useState } from 'react';
import { useLang } from '../i18n';

// Computes live open/closed status in the clinic's local time (America/Chicago).
// Hours: Tue–Sun 7 AM–12 PM & 2–7 PM · Monday closed.
const getStatus = (t) => {
  const central = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const day = central.getDay(); // 0 Sun … 6 Sat
  const h = central.getHours() + central.getMinutes() / 60;
  if (day === 1) return { tone: 'closed', label: t.status.closed }; // Monday
  if ((h >= 7 && h < 12) || (h >= 14 && h < 19)) return { tone: 'open', label: t.status.openNow };
  if (h < 7) return { tone: 'soon', label: `${t.status.opensAt} 7 AM` };
  if (h >= 12 && h < 14) return { tone: 'soon', label: `${t.status.opensAt} 2 PM` };
  return { tone: 'closed', label: t.status.closed };
};

const TONE = { open: '#1E4E8C', soon: '#1E4E8C', closed: '#A79E95' };

const OpenStatus = ({ compact = false, className = '' }) => {
  const { t } = useLang();
  const [st, setSt] = useState(() => getStatus(t));
  useEffect(() => {
    setSt(getStatus(t));
    const id = setInterval(() => setSt(getStatus(t)), 60000);
    return () => clearInterval(id);
  }, [t]);

  const dot = compact ? 8 : 10;
  const color = TONE[st.tone];
  return (
    <span
      data-testid="open-status"
      className={`inline-flex items-center gap-2 font-body ${className}`}
      style={{ fontSize: compact ? '12px' : '14px', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 600, color: '#1B1815' }}
    >
      <span className="relative flex" style={{ width: dot, height: dot }}>
        {st.tone === 'open' && (
          <span className="absolute inline-flex h-full w-full rounded-full" style={{ background: color, opacity: 0.45, animation: 'ping 1.6s cubic-bezier(0,0,0.2,1) infinite' }} />
        )}
        <span className="relative inline-flex rounded-full" style={{ width: '100%', height: '100%', background: color }} />
      </span>
      {st.label}
    </span>
  );
};

export default OpenStatus;
